import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import theme from '../../../../assets/stylesheets/_settings.global.scss';
import Actions from './actions';
import Header from './author-components/header';

const Byline = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${props => props.theme.isOnWireSide && `
    margin: 15px 0;
  `};

  > div.author-details {
    margin-right: 8px;

    > div.organization-details {
      display: flex;
      align-items: center;

      > p {
        margin-right: 8px;
      }
    }
  }
`;

const Position = styled.p`
  margin: 0;
  line-height: 120%;
  font-size: ${props => (props.theme.isExpanded ? 20 : 14)}px;
  font-weight: ${props => (props.theme.isExpanded
    ? props.theme.fontWeightBold
    : props.theme.fontWeightMedium
  )};
  ${props => props.theme.isExpanded && `
    line-height: 26px;
    text-transform: capitalize;
    color: ${props.theme.bodyColor};
  `};
`;

const Divider = styled.hr`
  display: block;
  width: 67px;
  height: 0px;
  margin: 0;
  border: 0;
  border-top: 2px dashed ${props => props.theme.primaryColor};
`;

const Org = styled.p`
  color: ${props => (props.theme.isExpanded ? props.theme.bodyColor : props.theme.secondaryColor)};
  margin: 0;
  font-size: 16px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  ${props => props.theme.isExpanded && `
    font-size: 20px;
    font-weight: ${props.theme.fontWeightBold};
    line-height: 26px;
    text-transform: capitalize;
  `};
  ${props => props.theme.isOnWireSide && `
    font-size: small;
    font-weight: 600;
    line-height: 1.2em;
    margin-top: 15px;
  `};
`;

export default function Author(props) {
  const {
    profile, isExpanded, isOnWireSide, clickDataAttributes,
  } = props;
  const isNotMobile = useMediaQuery({ query: `(min-width: ${theme.breakpointLargeMin})` });

  return (
    <Byline>
      <div className="author-details">
        <div>
          <Header
            profile={profile}
            isExpanded={isExpanded}
            isOnWireSide={isOnWireSide}
            clickDataAttributes={clickDataAttributes}
          />
          {!isOnWireSide && (
            <React.Fragment>
              {!!profile.position && (!profile.isCompanyProfile || !profile.organization) && <Position className="micro-profile-position">{profile.position}</Position>}
              {!isExpanded && <Divider />}
            </React.Fragment>
          )}
        </div>
        <div className="organization-details">
          {!!profile.organization && !profile.isCompanyProfile && <Org className="micro-profile-organization">{profile.organization}</Org>}
        </div>
      </div>
      {!!isNotMobile && <Actions />}
    </Byline>
  );
}

Author.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    slug: PropTypes.string,
    organization: PropTypes.string,
    position: PropTypes.string,
    isCompanyProfile: PropTypes.bool,
  }).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isOnWireSide: PropTypes.bool.isRequired,
  clickDataAttributes: PropTypes.shape({}),
};

Author.defaultProps = {
  clickDataAttributes: null,
};
